import { enUSMessages } from "./en-US"

type MessageId = keyof typeof enUSMessages

export const deDEMessages: Record<MessageId, string> = {
  ...enUSMessages,
  "app.authSetup.body":
    "Konfiguriere Clerk, bevor geschützte Routen und der nur per Einladung verfügbare Zugriff getestet werden können.",
  "account.accessRequiredBody":
    "Diese Kontofläche ist im aktuellen Zustand nicht verfügbar.",
  "account.accessRequiredTitle": "Konto nicht verfügbar",
  "account.identity.title": "Kontenidentität",
  "account.lede":
    "Verwalte Sprache, Gamer-Tag und dein verbundenes Clerk-Konto.",
  "account.loading": "Konto wird geladen…",
  "account.nav.defaultName": "Konto",
  "account.signInRequired": "Melde dich an, um dein Konto zu sehen.",
  "account.title": "Konto",
  "admin.accessRequiredBody":
    "Dieser Bereich ist nur für Bootstrap-Admins verfügbar.",
  "admin.accessRequiredTitle": "Adminzugriff erforderlich",
  "admin.lede":
    "Überprüfe Einladungen, Moderation, Sicherheits-Telemetrie und Admin-Nutzungsdaten.",
  "admin.systemBattleBots.basicHelp":
    "Starter-Einheit, mit der jeder Spieler im aktiven Feld und Deck beginnt.",
  "admin.systemBattleBots.basicTitle": "Basic Battle Bot",
  "admin.systemBattleBots.betterHelp":
    "Permanente Ausweich-Rekrutierung. Die Rekrutierungskosten folgen den abgeleiteten Kosten ({cost}).",
  "admin.systemBattleBots.betterTitle": "Better Battle Bot",
  "admin.systemBattleBots.sparkHelp":
    "Startereinheit — gibt beim Ausspielen 1 Energie.",
  "admin.systemBattleBots.sparkTitle": "Spark Bot",
  "admin.systemBattleBots.description":
    "Das sind Systemkarten, keine normalen Bibliothekskarten. Neue Matches übernehmen diese Konfiguration beim Start.",
  "admin.systemBattleBots.editTitle": "{name} bearbeiten",
  "admin.systemBattleBots.error.noSession":
    "Du musst angemeldet sein, um die System-Battle-Bots zu speichern.",
  "admin.systemBattleBots.error.saveFailed":
    "Die System-Battle-Bots konnten nicht gespeichert werden.",
  "admin.systemBattleBots.eyebrow": "Systemkarten",
  "admin.systemBattleBots.saved": "System-Battle-Bots gespeichert.",
  "admin.systemBattleBots.saving": "Wird gespeichert…",
  "admin.systemBattleBots.title": "Battle Bots",
  "admin.title": "Admin",
  "app.authSetup.bootstrapHelp":
    "Bootstrap-Admin-E-Mails schalten die Admin-Oberfläche frei. Spielerzugriff sollte über Clerk-Einladungslinks erfolgen, sobald der eingeschränkte Clerk-Registrierungsmodus aktiviert ist.",
  "app.authSetup.requiredEnv": "Erforderliche Umgebungsvariablen",
  "app.authSetup.title": "Authentifizierung muss eingerichtet werden",
  "cardEditor.moderationLabel": "Kartenname",
  "error.route.body":
    "In diesem Bereich ist ein unerwarteter Fehler aufgetreten. Du kannst ihn neu laden oder zu einem anderen Bereich wechseln.",
  "error.route.retry": "Erneut versuchen",
  "error.route.title": "Etwas ist schiefgelaufen",
  "filter.actions.apply": "Anwenden",
  "filter.actions.cancel": "Abbrechen",
  "common.cost": "Kosten",
  "filter.aria.clear": "Filter löschen",
  "filter.aria.input": "Tabellenzeilen filtern",
  "filter.aria.suggestions": "Filtervorschläge",
  "filter.appendValueTitle":
    "Mit Cmd/Strg-Klick wird dieser Wert hinzugefügt. Mit Alt/Option wird er ausgeschlossen.",
  "filter.fieldDetail": "Filterfeld",
  "filter.restoreError":
    "Der Tabellenfilter konnte nicht aus der URL wiederhergestellt werden.",
  "faction.blue": "Signal",
  "faction.colorless": "Farblos",
  "faction.green": "Thrive",
  "faction.purple": "Shadow",
  "faction.red": "Fury",
  "faction.yellow": "Command",
  "heroEditor.moderationLabel": "Heldenname",
  "heroEditor.randomize": "Stats zufällig",
  "heroEditor.validation.duplicateColor":
    "Die sekundäre Fraktion des Helden muss sich von der primären unterscheiden.",
  "heroEditor.validation.invalidProgressionOrder":
    "Die Heldenentwicklung muss die Stufen 1, 2 und 3 in dieser Reihenfolge enthalten.",
  "heroEditor.validation.skillAffinityMismatch":
    'Fähigkeit "{skillId}" ist für Stufe {level} nicht verfügbar.',
  "heroEditor.validation.tooManySkills":
    "Stufe {level} darf höchstens {max} Fähigkeiten haben.",
  "heroEditor.validation.unknownSkill":
    'Unbekannte Fähigkeit "{skillId}" auf Stufe {level}.',
  "invites.emailToInvite": "E-Mail für Freischaltung",
  "invites.fetchError.generic": "Einladungen konnten nicht geladen werden.",
  "invites.fetchError.unauthorized":
    "Melde dich als Bootstrap-Admin an, um Einladungen zu verwalten.",
  "invites.lede":
    "Erstelle echte Clerk-Einladungslinks für Spieler. Ein eingeladener Spieler kann den Link zum Registrieren oder Anmelden verwenden, und die Einladung gewährt CraftForce-Zugriff.",
  "invites.linkHelp":
    "Dadurch wird ein Clerk-Einladungslink erstellt und zum manuellen Teilen kopiert.",
  "invites.revokeError": "Einladung konnte nicht widerrufen werden.",
  "invites.sendInvite": "Einladung erstellen",
  "manage.tabs.aria": "Verwaltungsbereich",
  "manage.tabs.cards": "Karten",
  "manage.tabs.decks": "Decks",
  "manage.tabs.heroes": "Helden",
  "library.error.deleteFailed": "Löschen der Bibliothek fehlgeschlagen.",
  "library.error.fetchFailed": "Abruf der Bibliothek fehlgeschlagen.",
  "library.error.syncConflict":
    "Synchronisierungskonflikt mit dem Server. Lade zuerst die neueste Version, bevor du es erneut versuchst.",
  "library.error.syncFailed": "Synchronisierung der Bibliothek fehlgeschlagen.",
  "library.error.syncUnavailable":
    "Die Bibliothekssynchronisierung ist nicht verfügbar, weil keine Worker-URL konfiguriert ist.",
  "match.error.ATTACK_ALREADY_ATTACKED":
    "Diese Einheit kann in diesem Zug nicht erneut angreifen.",
  "match.error.ATTACK_BLOCKED_BY_GUARD":
    "Du musst zuerst eine Wache angreifen, sofern du Wache nicht umgehen kannst.",
  "match.error.ATTACK_INVALID_TARGET_ZONE":
    "Diese Einheit befindet sich nicht in einer angreifbaren Zone.",
  "match.error.ATTACK_NOT_IN_ATTACK_POSITION":
    "Nur die aktive Einheit oder eine Fernkampf-Einheit in der Unterstützungsreihe kann angreifen.",
  "match.error.ATTACK_NO_TARGET_ID":
    "Wähle vor dem Angriff eine Zieleinheit aus.",
  "match.error.ATTACK_SUPPORT_REQUIRES_BYPASS":
    "Du musst Wache umgehen können, bevor du diese Unterstützungseinheit angreifst.",
  "match.error.ATTACK_UNKNOWN_ATTACKER":
    "Die angreifende Einheit konnte nicht gefunden werden.",
  "match.error.ATTACK_UNKNOWN_TARGET":
    "Die Zieleinheit konnte nicht gefunden werden.",
  "match.error.CONCEDE_MATCH_OVER": "Das Match ist bereits beendet.",
  "match.error.END_TURN_WRONG_STEP":
    "Du kannst den Zug nur während des Hauptschritts beenden.",
  "match.error.JAM_NO_TARGET": "Störung benötigt eine gegnerische Zieleinheit.",
  "match.error.JAM_UNKNOWN_TARGET":
    "Das Ziel für Störung konnte nicht gefunden werden.",
  "match.error.LEVEL_UP_HERO_DEF_NOT_FOUND":
    "Die Heldendefinition für dieses Match konnte nicht gefunden werden.",
  "match.error.LEVEL_UP_HERO_EXHAUSTED":
    "Der Held ist erschöpft und kann in diesem Zug nicht aufsteigen.",
  "match.error.LEVEL_UP_INSUFFICIENT_ENERGY":
    "Du hast nicht genug Energie, um den Helden aufzuwerten.",
  "match.error.LEVEL_UP_NO_HERO_INSTANCE":
    "Die Heldeninstanz konnte nicht gefunden werden.",
  "match.error.LEVEL_UP_WRONG_LEVEL":
    "Helden müssen Stufe für Stufe aufsteigen.",
  "match.error.MATCH_COMPLETED": "Das Match ist bereits abgeschlossen.",
  "match.error.PLAY_CARD_ACTIVE_OCCUPIED":
    "Der aktive Slot ist belegt. Wechsle zuerst oder spiele in die Unterstützungsreihe.",
  "match.error.PLAY_CARD_NOT_IN_HAND":
    "Diese Karte befindet sich nicht mehr in deiner Hand.",
  "match.error.PLAY_CARD_REPLACE_NOT_IN_SUPPORT":
    "Die ausgewählte Ersatzkarte befindet sich nicht in der Unterstützungsreihe.",
  "match.error.PLAY_CARD_REPLACE_NOT_NEEDED":
    "Ein Ersetzen in der Unterstützungsreihe ist nur erlaubt, wenn sie voll ist.",
  "match.error.PLAY_CARD_SUPPORT_FULL":
    "Die Unterstützungsreihe ist voll. Ersetze zuerst eine Unterstützungseinheit.",
  "match.error.PLAY_CARD_UNKNOWN_INSTANCE":
    "Diese Karteninstanz konnte nicht gefunden werden.",
  "match.error.RECYCLE_INVALID_TARGET":
    "Recycling kann nur eine deiner Karten in der Hand oder im Spiel als Ziel wählen.",
  "match.error.RECYCLE_NO_TARGET":
    "Recycling benötigt eine deiner Karten als Ziel.",
  "match.error.RECRUIT_INSUFFICIENT_ENERGY":
    "Du hast nicht genug Energie, um diese Karte zu rekrutieren.",
  "match.error.RECRUIT_NO_SLOT_ID":
    "Wähle einen Slot in der Söldnerreihe zum Rekrutieren.",
  "match.error.RECRUIT_SLOT_NOT_IN_ROW":
    "Dieser Rekrutierungs-Slot befindet sich nicht mehr in einer Söldnerreihe.",
  "match.error.RECRUIT_UNKNOWN_INSTANCE":
    "Diese Rekrutierungskarte konnte nicht gefunden werden.",
  "match.error.SALVAGE_NO_DISCARD":
    "Du benötigst mindestens eine Karte im Ablagestapel, um Bergen zu verwenden.",
  "match.error.SHIFT_NOT_IN_SUPPORT":
    "Wechsel kann nur aus der Unterstützungsreihe verwendet werden.",
  "match.error.SHIFT_NO_ACTIVE":
    "Es gibt keine aktive Einheit zum Austauschen.",
  "match.error.SWAP_ALREADY_USED":
    "Du hast deinen normalen Wechsel in diesem Zug bereits verwendet.",
  "match.error.SWAP_NOT_IN_SUPPORT":
    "Diese Einheit befindet sich nicht in deiner Unterstützungsreihe.",
  "match.error.UNKNOWN_COMMAND": "Diese Match-Aktion wird nicht erkannt.",
  "match.error.USE_ABILITY_ALLY_REQUIREMENT":
    "Diese Fähigkeit benötigt mehr verbündete Einheiten im Spiel.",
  "match.error.USE_ABILITY_EXHAUSTED":
    "Diese Einheit ist erschöpft und kann diese Fähigkeit nicht einsetzen.",
  "match.error.USE_ABILITY_JAMMED":
    "Diese Einheit ist gestört und kann in diesem Zug keine erschöpfenden Fähigkeiten einsetzen.",
  "match.error.USE_ABILITY_NOT_ACTIVATED":
    "Diese Fähigkeit ist passiv und kann nicht direkt aktiviert werden.",
  "match.error.USE_ABILITY_NOT_OWNED":
    "Die Quelleneinheit muss eine deiner Einheiten im Spiel sein.",
  "match.error.USE_ABILITY_UNKNOWN_SKILL":
    "Diese Fähigkeit konnte nicht gefunden werden.",
  "match.error.USE_ABILITY_UNKNOWN_SOURCE":
    "Die Quelleneinheit konnte nicht gefunden werden.",
  "match.error.WRONG_SEAT": "Dieser Sitz ist nicht am Zug.",
  "match.error.WRONG_TURN": "Diese Aktion wurde für den falschen Zug gesendet.",
  "match.page.backToSetup": "Zurück zur Einrichtung",
  "match.page.connectionClosed":
    "Die Match-Verbindung wurde unerwartet geschlossen.",
  "match.page.connectionFailed": "Verbindung fehlgeschlagen",
  "match.page.connecting": "Verbinde mit Match {matchId}…",
  "match.page.joinByIdDescription":
    "Gib eine Match-ID ein, die dein Gegner geteilt hat, um dich zu verbinden.",
  "match.page.joinId": "Match-ID",
  "match.page.joinOnline": "Online-Match beitreten",
  "match.page.localHeading": "Lokal (Pass-and-Play)",
  "match.page.onlineHeading": "Online-Match beitreten",
  "match.page.pageEyebrow": "Matches",
  "match.page.pageTitle": "Match starten",
  "match.page.player1": "Spieler 1",
  "match.page.player1Seat": "Spieler 1 (Sitz A)",
  "match.page.player2": "Spieler 2",
  "match.page.player2Seat": "Spieler 2 (Sitz B)",
  "match.page.seatA": "Sitz A (Herausforderer)",
  "match.page.seatB": "Sitz B (Herausgeforderter)",
  "match.page.startLocal": "Lokales Match starten",
  "match.page.vs": "gegen",
  "match.page.yourSeat": "Dein Sitz",
  "match.setup.error.cardNotFound":
    'Karte "{cardId}" im Deck "{deckName}" konnte in der Kartenbibliothek nicht gefunden werden.',
  "match.setup.error.deckLoad":
    "Die ausgewählten Decks konnten nicht geladen werden.",
  "match.setup.error.deckNotFound":
    'Deck "{deckId}" konnte nicht gefunden werden.',
  "match.setup.error.deckWrongCardCount":
    'Deck "{deckName}" hat {count} Karten statt 24.',
  "match.setup.error.heroNotFound":
    'Der Held für Deck "{deckName}" konnte nicht gefunden werden.',
  "match.setup.error.player1Deck": "Spieler 1 muss ein Deck auswählen.",
  "match.setup.error.player2Deck": "Spieler 2 muss ein Deck auswählen.",
  "match.board.reconnecting":
    "Verbindung zum Match-Server wird wiederhergestellt. Befehle sind vorübergehend deaktiviert.",
  "match.board.reconnectingBlocked":
    "Die Verbindung zum Match-Server wird noch wiederhergestellt. Bitte gleich erneut versuchen.",
  "match.board.connectionUnstable":
    "Die Verbindung ist instabil. Der autoritative Match-Status wird wiederhergestellt.",
  "match.board.opponentDisconnected":
    "Dein Gegner ist getrennt. Timeout in etwa {seconds} Sekunden, wenn er nicht zurückkehrt.",
  "match.board.playerDisconnected": "Getrennt",
  "match.board.timeout.youLose":
    "Du hast verloren, weil deine Verbindung nicht rechtzeitig wiederhergestellt wurde.",
  "match.board.timeout.youWin":
    "Du hast gewonnen, weil dein Gegner nicht rechtzeitig wieder verbunden war.",
  "match.socket.INVALID_JSON":
    "Der Match-Server hat eine ungültige Befehlsnutzlast erhalten.",
  "match.socket.MATCH_NOT_INITIALIZED":
    "Das Match wurde auf dem Server noch nicht initialisiert.",
  "match.socket.WS_CONNECTION_FAILED":
    "Die WebSocket-Verbindung zum Match-Server ist fehlgeschlagen.",

  "match.hotSeat.readyTitle": "{name} ist dran",
  "match.hotSeat.playTurn": "Zug spielen",
  "match.hotSeat.opponentHand": "Gegnerhand: {count}",
  "match.hotSeat.heading": "Hot Seat",
  "match.hotSeat.deckLabel": "Deck (beide Spieler)",
  "match.hotSeat.startButton": "Hot Seat starten",

  "nav.close": "Navigation schließen",
  "nav.manage.label": "Verwalten",
  "nav.manage.short": "VW",
  "nav.open": "Navigation öffnen",
  "nav.play.label": "Spielen",
  "nav.play.short": "SP",
  "nav.primary": "Hauptnavigation",
  "nav.signIn": "Anmelden",
  "nav.signInShort": "AN",
  "nav.stats.label": "Statistik",
  "nav.theme.dark": "Zum dunklen Modus wechseln",
  "nav.theme.light": "Zum hellen Modus wechseln",
  "nav.toggle.collapse": "Navigation einklappen",
  "nav.toggle.expand": "Navigation ausklappen",
  "notFound.body": "Für {pathname} ist kein Bildschirm registriert.",
  "notFound.title": "Route nicht gefunden",
  "moderation.error.blockedLanguage": "{label} enthält gesperrte Sprache.",
  "settings.eyebrow.account": "Konto",
  "settings.language.description":
    "Wähle die Sprache der Oberfläche. CraftForce speichert die Auswahl in diesem Browser.",
  "settings.language.label": "Sprache",
  "settings.language.option.de-DE": "Deutsch",
  "settings.language.option.en-US": "Englisch (US)",
  "settings.language.option.fr-FR": "Französisch",
  "settings.language.option.zh-Hans": "Chinesisch (vereinfacht)",
  "settings.language.option.zh-Hant": "Chinesisch (traditionell)",
  "settings.language.title": "Sprache der Oberfläche",
  "settings.lede":
    "Verwalte dein Spielerprofil, deinen Gamer-Tag und deine Kontodetails.",
  "settings.loading": "Konto wird geladen…",
  "settings.signInRequired":
    "Melde dich an, um dein Profil und deine Kontoeinstellungen anzuzeigen.",
  "settings.title": "Einstellungen",
  "friends.actionError.playerSyncUnavailable":
    "Dieser Spieler ist noch nicht für Online-Herausforderungen verfügbar. Bitte ihn, CraftForce einmal angemeldet zu öffnen.",
  "friends.alias.add": "Spitznamen hinzufügen",
  "friends.alias.clear": "Spitznamen entfernen",
  "friends.alias.edit": "Spitznamen bearbeiten",
  "friends.alias.error.blocked": "Dieser Spitzname enthält gesperrte Sprache.",
  "friends.alias.error.length":
    "Spitznamen müssen zwischen 1 und 30 Zeichen lang sein.",
  "friends.alias.label": "Dein privater Spitzname für diesen Freund",
  "friends.alias.placeholder": "Optionaler privater Spitzname",
  "friends.challengeAnother":
    "Fordere nur bestätigte Freunde zu einem servergestützten Online-Match heraus.",
  "friends.friendsTab": "Freunde",
  "friends.friendCode.alreadyFriends":
    "Du bist bereits mit diesem Spieler befreundet.",
  "friends.friendCode.enterLabel": "Freundescode",
  "friends.friendCode.help":
    "Teile diesen Code, damit dir ein anderer eingeladener Spieler eine Freundschaftsanfrage senden kann.",
  "friends.friendCode.label": "Dein Freundescode",
  "friends.friendCode.notFound":
    "Dieser Freundescode konnte keinem eingeladenen Spieler zugeordnet werden.",
  "friends.friendCode.pendingExists":
    "Zwischen euch besteht bereits eine ausstehende Freundschaftsanfrage.",
  "friends.friendCode.placeholder": "Freundescode eingeben",
  "friends.friendCode.regenerate": "Neu erzeugen",
  "friends.friendCode.required": "Gib zuerst einen Freundescode ein.",
  "friends.friendCode.self":
    "Du kannst dir nicht selbst eine Freundschaftsanfrage senden.",
  "friends.friendCode.send": "Freundschaftsanfrage senden",
  "friends.friendRequestNotification.body":
    "{requesterTag} hat dir eine Freundschaftsanfrage geschickt.",
  "friends.friendRequestNotification.title": "Neue Freundschaftsanfrage",
  "friends.inboxCallout.multiple":
    "{count} eingehende Herausforderungen warten in deinem Posteingang.",
  "friends.inboxCallout.single":
    "{challengerTag} hat dir eine Herausforderung geschickt.",
  "friends.inboxCallout.title": "Eingehende Herausforderungen",
  "friends.notification.accepted":
    "Die Herausforderung mit {playerTag} wurde angenommen.",
  "friends.notification.body": "{challengerTag} hat dich herausgefordert.",
  "friends.notification.cancelled":
    "Die Herausforderung mit {playerTag} wurde abgebrochen.",
  "friends.notification.declined":
    "Die Herausforderung mit {playerTag} wurde abgelehnt.",
  "friends.notification.statusTitle": "Herausforderungs-Update",
  "friends.notification.title": "Neue Herausforderung",
  "friends.openChallenges": "Herausforderungen öffnen",
  "friends.noPlayers":
    "Noch keine bestätigten Freunde. Teile deinen Freundescode, um deine Liste aufzubauen.",
  "friends.playerRecentlySeen": "Kürzlich gesehen",
  "friends.playerSeenEarlier": "Früher gesehen",
  "friends.playerUnavailable": "Nicht verfügbar",
  "friends.requests.emptyIncoming": "Keine eingehenden Freundschaftsanfragen.",
  "friends.requests.emptyOutgoing": "Keine ausgehenden Freundschaftsanfragen.",
  "friends.requests.incoming": "Eingehende Anfragen",
  "friends.requests.outgoing": "Ausgehende Anfragen",
  "skill.armor.description":
    "Jeder Treffer gegen diese Einheit wird um 1 reduziert.",
  "skill.armor.name": "Panzerung",
  "skill.breakthrough.description":
    "Wenn diese Einheit ein Ziel im Kampf zerstört, kann übriger Angriff in diesem Zug für einen weiteren Angriff verwendet werden.",
  "skill.breakthrough.name": "Durchbruch",
  "skill.broker.description": "Erschöpfen: Erhalte in diesem Zug 1 Energie.",
  "skill.broker.name": "Broker",
  "skill.charge.description":
    "Solange diese Einheit in der Unterstützungsreihe ist, erzeugt sie zu Beginn deines Zuges 1 Energie.",
  "skill.charge.name": "Ladung",
  "skill.deploy.description":
    "Wenn du diese Einheit spielst, füge der aktiven Einheit des Gegners 1 Schaden zu.",
  "skill.deploy.name": "Einsatz",
  "skill.focus.description": "Wenn diese Einheit angreift, erhalte 1 Energie.",
  "skill.focus.name": "Fokus",
  "skill.generator.description":
    "Solange diese Einheit in der Unterstützungsreihe ist, erzeugt jede deiner Ladung-Einheiten in der Unterstützungsreihe zu Beginn deines Zuges +1 Energie.",
  "skill.generator.name": "Generator",
  "skill.guard.description":
    "Solange du eine Wache kontrollierst, müssen gegnerische Angriffe eine Wache als Ziel wählen, sofern sie Wache nicht umgehen.",
  "skill.guard.name": "Wache",
  "skill.jam.description":
    "Erschöpfen: Eine gegnerische Einheit kann in ihrem nächsten Zug nicht angreifen oder erschöpfende Fähigkeiten einsetzen.",
  "skill.jam.name": "Störung",
  "skill.ko.description":
    "Wenn diese Einheit einen Gegner zerstört, ziehe eine Karte.",
  "skill.ko.name": "K.-o.",
  "skill.rally.description":
    "Erschöpfen: Diese Einheit erhält bis zum Ende des Zuges +1 Angriff.",
  "skill.rally.name": "Sammeln",
  "skill.ranged.description":
    "Diese Einheit kann aus der Unterstützungsreihe angreifen.",
  "skill.ranged.name": "Fernkampf",
  "skill.recover.description": "Erschöpfen: Mache deine aktive Einheit bereit.",
  "skill.recover.name": "Bereitmachen",
  "skill.recycle.description":
    "Erschöpfen: Wirf eine deiner Karten aus der Hand oder vom Spielfeld ab und ziehe dann 2 Karten.",
  "skill.recycle.name": "Recycling",
  "skill.repair.description":
    "Erschöpfen: Diese Einheit erhält +2 Gesundheit bis nach dem nächsten Zug deines Gegners.",
  "skill.repair.name": "Reparatur",
  "skill.salvage.description":
    "Erschöpfen: Nimm die oberste Karte deines Ablagestapels auf deine Hand.",
  "skill.salvage.name": "Bergen",
  "skill.scout.description": "Erschöpfen: Ziehe eine Karte.",
  "skill.scout.name": "Spähen",
  "skill.scrap.description":
    "Erschöpfen: Verschrotte diese Einheit und ziehe eine Karte.",
  "skill.scrap.name": "Verschrotten",
  "skill.shield.description":
    "Erschöpfen: Deine aktive Einheit erhält +1 Gesundheit bis nach dem nächsten Zug deines Gegners.",
  "skill.shield.name": "Schild",
  "skill.shift.description":
    "Erschöpfen: Bewege diese Einheit zwischen der aktiven und der Unterstützungsreihe.",
  "skill.shift.name": "Wechsel",
  "skill.sneak.description":
    "Wenn diese Einheit angreift, kann sie Wache ignorieren und das Zentralkommando oder jede Einheit angreifen.",
  "skill.sneak.name": "Schleichen",
  "skill.swift.description":
    "Diese Einheit kann in dem Zug angreifen, in dem sie in den aktiven Slot kommt oder in ihn gewechselt wird.",
  "skill.swift.name": "Schnell",
  "skillsEditor.detail.previewAlly": "{sign} {cost} Verbündeten-Anforderung",
  "skillsEditor.detail.previewBase": "Basis: {cost}",
  "skillsEditor.detail.previewMode": "{sign} {cost} Modus",
  "stats.body": "Balance-Analysen und Match-Verlauf folgen bald.",
  "stats.title": "Statistik",
  "deckEditor.randomDeck": "Zufälliges Deck",
  "deckEditor.colorPreferenceAny": "Jede Farbe",
  "deckEditor.validation.duplicateEntry":
    'Karte "{cardId}" erscheint mehr als einmal im Deck.',
  "deckEditor.validation.tooFewLowCost":
    "Mindestens {min} Söldnerkarten müssen {threshold} oder weniger kosten. Dieses Deck hat {count}.",
  "deckEditor.validation.tooManyHighCost":
    "Höchstens {max} Söldnerkarten dürfen {threshold} oder mehr kosten. Dieses Deck hat {count}.",
  "deckEditor.validation.unknownCards":
    "{count, plural, one {# Karte in diesem Deck konnte nicht aufgelöst werden. Speichere alle Karten vor der Validierung.} other {# Karten in diesem Deck konnten nicht aufgelöst werden. Speichere alle Karten vor der Validierung.}}",
  "table.bulk.randomize": "Zufällig",
  "table.bulk.syncSelection": "Auswahl synchronisieren",
  "table.sync.conflict": "Konflikt",
  "table.origin.local": "Lokaler Entwurf",
  "table.refresh.failed":
    "Remote-Aktualisierung fehlgeschlagen. Zwischengespeicherte Daten werden angezeigt.",
  "table.refresh.idle": "Es wird mit dem lokalen Cache gearbeitet.",
  "table.refresh.last": "Remote aktualisiert: {time}",
  "table.refresh.offline":
    "Offline. Lokal zwischengespeicherte Daten werden verwendet.",
  "table.rowAction.pullRemote": "Neueste Remote-Version von {name} laden",
  "table.rowAction.sync": "{name} synchronisieren",
  "ui.artwork.sync.localOnly":
    "Nur lokal gespeichert. Serversynchronisierung nicht verfügbar.",
  "ui.artwork.sync.retrying": "Serversynchronisierung wird erneut versucht...",
  "ui.artwork.sync.synced": "Mit dem Server synchronisiert.",
  "ui.artwork.sync.syncing": "Mit dem Server wird synchronisiert...",
  "ui.artwork.error.heicUnsupported":
    "Dieser Browser konnte das ausgewaehlte HEIC- oder HEIF-Bild nicht dekodieren. Versuche stattdessen JPEG, PNG oder WebP.",
}
